import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import { useStateIfMounted } from 'use-state-if-mounted'
import { useDispatch, useSelector } from 'react-redux'
import {
    actualizarFC_31Estatus,
    agregarMapFC_31Accion,
    actualizarFC_31Solicitud,
    actualizarMapFC_31Accion,
    obtenerSolicitudDetalleFC_31,
    generarDocumentosFC_31,
    obtenerIdCliente,
    guardarCambiosFC_31Solicitud,
    agregarFC_31AnexoAjuste,
    agregarFC_31AnexoMuestra,
    agregarFC_31AnexoIngreso,
    resetDataFC_31,
    actualizarFC_31SolicitudModal
} from '../../../redux/DucksAtencionACliente/FC_31AtencionAClienteDucks'
import { AcualizarFormatoAccion } from '../../../redux/AtencionAClienteDucks'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import TablaAtencionACliente from '../../App/TablaAtencionACliente';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import TablaDocumentacion from '../../App/TablaDocumentacion';
import { v4 as uuidv4 } from 'uuid';
import TablaProductoMuestreo from './TablaProductoMuestreo';
import TablaProductoIngresoMaduracion from './TablaProductoIngresoMaduracion';
import TablaProductoLiberacionMaduracion from './TablaProductoLiberacionMaduracion';
const { useEffect, useRef } = React;
import estilos from './AtencionAClientesFC_31Component.module.css'
import FormularioDocumentacionFC_31 from './FormularioDocumentacionFC_31';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
const styleDevolver = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function FC_31Component(props) {
    const dispatch = useDispatch()
    var fechaHoy = moment().format('YYYY-MM-DD');
    const usuario = useSelector(store => store.Usuario)
    const tipoUsuario = useSelector(store => store.Usuario.tipoUsuario)
    const solicitud = useSelector(store => store.FC_31SolicitudAtencionACliente.data)
    let fc_31Map = useSelector(store => store.FC_31SolicitudAtencionACliente.fc_31Map)
    let fc_31MuestreoMap = useSelector(store => store.FC_31SolicitudAtencionACliente.anexosMuestreoMap)
    let filesMuestreoMap = useSelector(store => store.FC_31SolicitudAtencionACliente.filesMuestreoMap)
    let fc_31IngresoMap = useSelector(store => store.FC_31SolicitudAtencionACliente.anexosIngresoMap)
    let filesIngresoMap = useSelector(store => store.FC_31SolicitudAtencionACliente.filesIngresoMap)
    let fc_31LiberacionMap = useSelector(store => store.FC_31SolicitudAtencionACliente.anexosLiberacionMap)
    const idUsuario = usuario.data.user[0].id
    const currentUser = useSelector(store => store.Usuario.data)
    const dataUser = useSelector(store => store.Usuario.user)
    
    /*Controlar las el formulario con las paginas*/
    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1, 2])
    const modoVerDetalle = useSelector(store => store.FC_31SolicitudAtencionACliente.modoVerDetalle)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos solicitante', 'Documentación'])
    React.useEffect(() => {
        let totalDePaginas = 2
        const nuevosApartados = ['Datos solicitante']
        if (solicitud.muestreo) {
            totalDePaginas++
            let nombreApartado = 'Muestreo'
            nuevosApartados.push(nombreApartado)
        }
        if (solicitud.ingresomaduracion) {
            totalDePaginas++
            let nombreApartado = 'Ingreso a maduración'
            nuevosApartados.push(nombreApartado)
        }
        if (solicitud.liberacionmaduracion) {
            totalDePaginas++
            let nombreApartado = 'Liberación de maduración'
            nuevosApartados.push(nombreApartado)
        }
        nuevosApartados.push('Documentación')
        let nuevasPaginas = []
        for (let index = 1; index <= totalDePaginas; index++) {
            nuevasPaginas.push(index)
        }
        setPaginas(nuevasPaginas)
        setNombresParaPaginas(nuevosApartados)
    }, [solicitud])
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }
    let cortetipoinstalacion = solicitud.tipoinstalacion.split('/')
    let tipoUnidad = ''
    if(cortetipoinstalacion[0] == '1')tipoUnidad = 'Unidad de producción'
    if(cortetipoinstalacion[0] == '2')tipoUnidad = 'Unidad de envasado'
    if(cortetipoinstalacion[0] != '1' && cortetipoinstalacion[0] != '2'){
        let corte = cortetipoinstalacion[0].split('-')
        tipoUnidad = 'Unidad de almacén: ' + corte[1]
    }

    let pagina1 = []
    pagina1.push(
        {
            id: uuidv4(), Campo: 'Fecha de visita propuesta', valor: solicitud.fechapropuesta.substring(0, 10), idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.fechapropuesta : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? !fc_31Map?.fechapropuestacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.fechapropuestacheck : false,
        },
        {
            id: uuidv4(), Campo: 'Tipo de instalación', valor: tipoUnidad, idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.tipoinstalacion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? !fc_31Map?.tipoinstalacioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.tipoinstalacioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Nombre del responsable', valor: solicitud.responsableinstalaciones, idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.responsableinstalaciones : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? !fc_31Map?.responsableinstalacionescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.responsableinstalacionescheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo Electrónico', valor: solicitud.correoelectronico, idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? !fc_31Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.correoelectronicocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono, idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? !fc_31Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.telefonocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Domicilio completo', valor: solicitud.domicilio, idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.domicilio : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? !fc_31Map?.domiciliocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.domiciliocheck : false,
        },
    )
    if (solicitud.muestreo) pagina1.push(
        {
            id: uuidv4(), Campo: 'Muestreo', valor: solicitud.muestreo === true ? 'Si' : 'No', idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.fechapropuesta : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? !fc_31Map?.fechapropuestacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.fechapropuestacheck : false,
        })
    if (solicitud.ingresomaduracion) pagina1.push(
        {
            id: uuidv4(), Campo: 'Ingreso a maduración', valor: solicitud.ingresomaduracion === true ? 'Si' : 'No', idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.fechapropuesta : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? !fc_31Map?.fechapropuestacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.fechapropuestacheck : false,
        })
    if (solicitud.liberacionmaduracion) pagina1.push(
        {
            id: uuidv4(), Campo: 'Liberación de maduración', valor: solicitud.liberacionmaduracion === true ? 'Si' : 'No', idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.fechapropuesta : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? !fc_31Map?.fechapropuestacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_31Map) && JSON.stringify([]) !== JSON.stringify(fc_31Map) ? fc_31Map?.fechapropuestacheck : false,
        })
    let [rowspagina1, setRowsPagina1] = React.useState(pagina1)
    let pagina5 = []
    let pagina2 = []
    if (solicitud.muestreo) pagina5.push({ id: uuidv4(), nameDoc: 'Documentación de muestreo' })
    for (const i in solicitud.fc_31_anexomuestreo) {
        let filtro = fc_31MuestreoMap?.filter(anexo => anexo?.idfc31_anexomuestreo === solicitud?.fc_31_anexomuestreo?.[i]?.idfc31_anexomuestreo)
        pagina2.push(
            {
                id: uuidv4(), idfc31_anexomuestreo: solicitud?.fc_31_anexomuestreo?.[i]?.idfc31_anexomuestreo,
                idfc31_anexomuestreomap: filtro?.[0]?.idfc31_anexomuestreomap ? filtro[0]?.idfc31_anexomuestreomap : '',
                numerolote: solicitud?.fc_31_anexomuestreo?.[i]?.numerolote,
                volumen: solicitud?.fc_31_anexomuestreo?.[i]?.volumen,
                contenidoalcoholico: solicitud?.fc_31_anexomuestreo?.[i]?.contenidoalcoholico,
                analisis: solicitud?.fc_31_anexomuestreo?.[i]?.analisis,
                informacionadicional: solicitud?.fc_31_anexomuestreo?.[i]?.informacionadicional,
                ajuste: solicitud?.fc_31_anexomuestreo?.[i]?.ajuste === true ? '✔' : '',
                mezcla: solicitud?.fc_31_anexomuestreo?.[i]?.mezcla === true ? '✔' : '',
                Campo: '',
                observaciones: filtro[0] ? filtro[0].muestreo : '',
                correcto: filtro[0] ? !filtro[0].muestreocheck : false,
                incorrecto: filtro[0] ? filtro[0].muestreocheck : false,
            }
        )
        let nameid = `DMAL${i}`.toString()
        const filtroAnalisis = solicitud.fc_31_anexomuestreo[i].fc_31archivomuestreo.filter(anexo => anexo.nameid === nameid)
        const filtroMapMuestreo = filesMuestreoMap?.filter(anexo => anexo?.idfc_31archivomuestreo === filtroAnalisis?.[0]?.idfc_31archivomuestreo)

        pagina5.push({
            id: uuidv4(),
            observaciones: filtroMapMuestreo?.[0]?.observacion ? filtroMapMuestreo?.[0]?.observacion : '',
            correcto: filtroMapMuestreo?.[0] ? !filtroMapMuestreo?.[0]?.estatuscheck : false,
            incorrecto: filtroMapMuestreo?.[0] ? filtroMapMuestreo?.[0]?.estatuscheck : false,
            fechaInicio: filtroAnalisis?.[0]?.fechainicio ? filtroAnalisis?.[0]?.fechainicio : '',
            fechaTermino: filtroAnalisis?.[0]?.fechafin ? filtroAnalisis?.[0]?.fechafin : '',
            estatus: filtroAnalisis?.[0]?.estatus ? filtroAnalisis?.[0]?.estatus : 'Agregar',
            idMap: filtroMapMuestreo?.[0] ? filtroMapMuestreo?.[0]?.idfc_31archivomuestreomap : '',
            idfc_31archivomuestreo: filtroAnalisis?.[0]?.idfc_31archivomuestreo,
            tabla: 'fc_31archivomuestreo', nombreId: 'idfc31_anexomuestreo', idSolicitud: solicitud?.fc_31_anexomuestreo?.[i]?.idfc31_anexomuestreo,
            nameid: `DMAL${i}`, nameDoc: 'Análisis de Laboratorio: '
        })
    }
    let [rowspagina2, setRowsPagina2] = React.useState(pagina2)

    if (solicitud.ingresomaduracion) pagina5.push({ id: uuidv4(), nameDoc: 'Documentación ingreso a maduración' })
    let pagina3 = []
    for (const i in solicitud.fc_31_anexoingresomaduracion) {
        let filtro = fc_31IngresoMap?.filter(anexo => anexo?.idfc31_anexoingresomaduracion === solicitud?.fc_31_anexoingresomaduracion?.[i]?.idfc31_anexoingresomaduracion)
        pagina3.push(
            {
                id: uuidv4(), idfc31_anexoingresomaduracion: solicitud?.fc_31_anexoingresomaduracion?.[i]?.idfc31_anexoingresomaduracion,
                idfc31_anexoingresomaduracionmap: filtro?.[0]?.idfc31_anexoingresomaduracionmap ? filtro[0]?.idfc31_anexoingresomaduracionmap : '',
                numerolote: solicitud?.fc_31_anexoingresomaduracion?.[i]?.numerolote,
                fechaingreso: solicitud?.fc_31_anexoingresomaduracion?.[i]?.fechaingreso.substring(0, 10),
                numeroanalisis: solicitud?.fc_31_anexoingresomaduracion?.[i]?.numeroanalisis,
                informacionadicional: solicitud?.fc_31_anexoingresomaduracion?.[i]?.informacionadicional,
                volumen: solicitud?.fc_31_anexoingresomaduracion?.[i]?.volumen,
                contenidoalcoholico: solicitud?.fc_31_anexoingresomaduracion?.[i]?.contenidoalcoholico,
                Campo: '',
                observaciones: filtro[0] ? filtro[0].ingreso : '',
                correcto: filtro[0] ? !filtro[0].ingresocheck : false,
                incorrecto: filtro[0] ? filtro[0].ingresocheck : false,
            }
        )
        let nameid = `DIAL${i}`.toString()
        const filtroAnalisis = solicitud?.fc_31_anexoingresomaduracion[i].fc_31archivoingreso.filter(anexo => anexo.nameid === nameid)
        const filtroMapIngreso = filesIngresoMap?.filter(anexo => anexo?.idfc_31archivoingreso === filtroAnalisis?.[0]?.idfc_31archivoingreso)

        pagina5.push({
            id: uuidv4(),
            observaciones: filtroMapIngreso?.[0]?.observacion ? filtroMapIngreso?.[0]?.observacion : '',
            correcto: filtroMapIngreso?.[0] ? !filtroMapIngreso?.[0]?.estatuscheck : false,
            incorrecto: filtroMapIngreso?.[0] ? filtroMapIngreso?.[0]?.estatuscheck : false,
            fechaInicio: filtroAnalisis?.[0]?.fechainicio ? filtroAnalisis?.[0]?.fechainicio : '',
            fechaTermino: filtroAnalisis?.[0]?.fechafin ? filtroAnalisis?.[0]?.fechafin : '',
            estatus: filtroAnalisis?.[0]?.estatus ? filtroAnalisis?.[0]?.estatus : 'Agregar',
            idMap: filtroMapIngreso?.[0] ? filtroMapIngreso?.[0]?.idfc_31archivoingresomap : '',
            idfc_31archivoingreso: filtroAnalisis?.[0]?.idfc_31archivoingreso,
            tabla: 'fc_31archivoingreso', nombreId: 'idfc31_anexoingresomaduracion',
            idSolicitud: solicitud?.fc_31_anexoingresomaduracion?.[i]?.idfc31_anexoingresomaduracion,
            nameid: `DIAL${i}`, nameDoc: 'Análisis de Laboratorio: '
        })
    }
    let [rowspagina3, setRowsPagina3] = React.useState(pagina3)

    let pagina4 = []
    for (const i in solicitud.fc_31_anexoliberacionmaduracion) {
        let filtro = fc_31LiberacionMap?.filter(anexo => anexo?.idfc31_anexoliberacionmaduracion === solicitud?.fc_31_anexoliberacionmaduracion[i]?.idfc31_anexoliberacionmaduracion)
        pagina4.push(
            {
                id: uuidv4(), idfc31_anexoliberacionmaduracion: solicitud?.fc_31_anexoliberacionmaduracion?.[i]?.idfc31_anexoliberacionmaduracion,
                idfc31_anexoliberacionmaduracionmap: filtro?.[0]?.idfc31_anexoliberacionmaduracionmap ? filtro[0]?.idfc31_anexoliberacionmaduracionmap : '',
                numerorecipientes: solicitud?.fc_31_anexoliberacionmaduracion?.[i]?.numerorecipientes,
                materialrecipientes: solicitud?.fc_31_anexoliberacionmaduracion?.[i]?.materialrecipientes,
                numerolote: solicitud?.fc_31_anexoliberacionmaduracion?.[i]?.numerolote,
                capacidad: solicitud?.fc_31_anexoliberacionmaduracion?.[i]?.capacidad,
                volumen: solicitud?.fc_31_anexoliberacionmaduracion?.[i]?.volumen,
                contenidoalcoholico: solicitud?.fc_31_anexoliberacionmaduracion?.[i]?.contenidoalcoholico,
                unidad: solicitud?.fc_31_anexoliberacionmaduracion?.[i]?.unidad,
                informacionadicional: solicitud?.fc_31_anexoliberacionmaduracion?.[i]?.informacionadicional,
                Campo: '',
                observaciones: filtro[0] ? filtro[0].liberacion : '',
                correcto: filtro[0] ? !filtro[0].liberacioncheck : false,
                incorrecto: filtro[0] ? filtro[0].liberacioncheck : false,
            }
        )
    }
    let [rowspagina4, setRowsPagina4] = React.useState(pagina4)
    let [rowspagina5, setRowsPagina5] = React.useState(pagina5)

    const handdleEditPrev = (objectProducto) => {
        const filtroGeneral = rowspagina1.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroMuestreo = rowspagina2.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroIngreso = rowspagina3.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroLiberacion = rowspagina4.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDocumentacion = rowspagina5.findIndex(anexo => anexo.id === objectProducto.id)
        if (filtroGeneral !== -1) {
            rowspagina1[filtroGeneral].valor = objectProducto.valor
            rowspagina1[filtroGeneral].correcto = objectProducto.correcto
            rowspagina1[filtroGeneral].incorrecto = objectProducto.incorrecto
            rowspagina1[filtroGeneral].observaciones = objectProducto.observaciones
        }
        if (filtroMuestreo !== -1) {
            rowspagina2[filtroMuestreo].valor = objectProducto.valor
            rowspagina2[filtroMuestreo].correcto = objectProducto.correcto
            rowspagina2[filtroMuestreo].incorrecto = objectProducto.incorrecto
            rowspagina2[filtroMuestreo].observaciones = objectProducto.observaciones
        }
        if (filtroIngreso !== -1) {
            rowspagina3[filtroIngreso].valor = objectProducto.valor
            rowspagina3[filtroIngreso].correcto = objectProducto.correcto
            rowspagina3[filtroIngreso].incorrecto = objectProducto.incorrecto
            rowspagina3[filtroIngreso].observaciones = objectProducto.observaciones
        }
        if (filtroLiberacion !== -1) {
            rowspagina4[filtroLiberacion].valor = objectProducto.valor
            rowspagina4[filtroLiberacion].correcto = objectProducto.correcto
            rowspagina4[filtroLiberacion].incorrecto = objectProducto.incorrecto
            rowspagina4[filtroLiberacion].observaciones = objectProducto.observaciones
        }
        if (filtroDocumentacion !== -1) {
            //rowspagina2[filtroDocumentacion].valor = objectProducto.valor
            rowspagina5[filtroDocumentacion].correcto = objectProducto.correcto
            rowspagina5[filtroDocumentacion].incorrecto = objectProducto.incorrecto
            rowspagina5[filtroDocumentacion].observaciones = objectProducto.observaciones
        }
    }
    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_31Map) || JSON.stringify([]) === JSON.stringify(fc_31Map) || fc_31Map === null) {
            await agregarMapYActualizarFC_31()
            const idSolicitud = solicitud.idfc31_solicitudseguimiento
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_31 = 6
            const tabla = tablaFC_31
            await dispatch(actualizarFC_31Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_31()
            const idSolicitud = solicitud.idfc31_solicitudseguimiento
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_31 = 6
            const tabla = tablaFC_31
            await dispatch(actualizarFC_31Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const agregarMapYActualizarFC_31 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        principal.push({
            idfc31_solicitudseguimiento: rowspagina1[0].idfc31_solicitudseguimiento,
            responsableinstalaciones: rowspagina1[2].valor,
            correoelectronico: rowspagina1[3].valor, telefono: rowspagina1[4].valor,
            domicilio: rowspagina1[5].valor, fechasolicitud: fechaSolicitudAceptada
        })
        let principalMap = []
        principalMap.push({
            fechapropuesta: rowspagina1[0].observaciones,
            tipoinstalacion: rowspagina1[1].observaciones,
            responsableinstalaciones: rowspagina1[2].observaciones,
            correoelectronico: rowspagina1[3].observaciones,
            telefono: rowspagina1[4].observaciones,
            domicilio: rowspagina1[5].observaciones,

            fechapropuestacheck: rowspagina1[0].incorrecto,
            tipoinstalacioncheck: rowspagina1[1].incorrecto,
            responsableinstalacionescheck: rowspagina1[2].incorrecto,
            correoelectronicocheck: rowspagina1[3].incorrecto,
            telefonocheck: rowspagina1[4].incorrecto,
            domiciliocheck: rowspagina1[5].incorrecto,
            idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
        })
        for (const i in rowspagina1) {
            if (rowspagina1?.[i].Campo === 'Muestreo') principalMap.push({ muestreo: rowspagina1[i].observaciones, muestreocheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Ingreso a maduración') principalMap.push({ ingresomaduracion: rowspagina1[i].observaciones, ingresomaduracioncheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Liberación de maduración') principalMap.push({ liberacionmaduracion: rowspagina1[i].observaciones, liberacionmaduracioncheck: rowspagina1[i].incorrecto })
        }
        let obj_unidos = {}
        for (const i in principalMap) {
            obj_unidos = Object.assign(obj_unidos, principalMap[i])
        }

        let muestreoMap = []
        for (const producto of rowspagina2) {
            muestreoMap.push({ muestreo: producto.observaciones, muestreocheck: producto.incorrecto, idfc31_anexomuestreo: producto.idfc31_anexomuestreo })
        }
        let ingresoMap = []
        for (const producto of rowspagina3) {
            ingresoMap.push({ ingreso: producto.observaciones, ingresocheck: producto.incorrecto, idfc31_anexoingresomaduracion: producto.idfc31_anexoingresomaduracion })
        }
        let liberacionMap = []
        for (const producto of rowspagina4) {
            liberacionMap.push({ liberacion: producto.observaciones, liberacioncheck: producto.incorrecto, idfc31_anexoliberacionmaduracion: producto.idfc31_anexoliberacionmaduracion })
        }

        let archivosMuestreoMap = []
        for (const anexo in rowspagina5) {
            let nameid = rowspagina5[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DMAL") {
                archivosMuestreoMap.push({
                    estatuscheck: rowspagina5[anexo]?.incorrecto, observacion: rowspagina5[anexo]?.observaciones,
                    idfc_31archivomuestreo: rowspagina5[anexo]?.idfc_31archivomuestreo,
                })
            }
        }

        let archivosIngresoMap = []
        for (const anexo in rowspagina5) {
            let nameid = rowspagina5[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DIAL") {
                archivosIngresoMap.push({
                    estatuscheck: rowspagina5[anexo]?.incorrecto, observacion: rowspagina5[anexo]?.observaciones,
                    idfc_31archivoingreso: rowspagina5[anexo]?.idfc_31archivoingreso,
                })
            }
        }

        let archivosMuestreo = []
        for (const anexo in rowspagina5) {
            let nameid = rowspagina5[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DMAL") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowspagina5[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina5[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowspagina5[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina5[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosMuestreo.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_31archivomuestreo: rowspagina5[anexo]?.idfc_31archivomuestreo
                })
            }
        }
        let archivosIngreso = []
        for (const anexo in rowspagina5) {
            let nameid = rowspagina5[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DIAL") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowspagina5[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina5[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowspagina5[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina5[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosIngreso.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_31archivoingreso: rowspagina5[anexo]?.idfc_31archivoingreso
                })
            }
        }
        let formato = { solicitud: principal[0], archivosMuestreo: archivosMuestreo, archivosIngreso: archivosIngreso }
        let formatoMap = {
            solicitud: obj_unidos, muestreoMap: muestreoMap, ingresoMap: ingresoMap, liberacionMap: liberacionMap,
            archivosMuestreoMap: archivosMuestreoMap, archivosIngresoMap: archivosIngresoMap
        }
        await dispatch(agregarMapFC_31Accion(formatoMap))
        await dispatch(actualizarFC_31Solicitud(formato))
        return
    }

    const actualizarMapYActualizarFC_31 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        principal.push({
            idfc31_solicitudseguimiento: rowspagina1[0].idfc31_solicitudseguimiento,
            responsableinstalaciones: rowspagina1[2].valor,
            correoelectronico: rowspagina1[3].valor, telefono: rowspagina1[4].valor,
            domicilio: rowspagina1[5].valor, fechasolicitud: fechaSolicitudAceptada
        })
        let principalMap = []
        principalMap.push({
            idfc31_solicitudseguimientomap: fc_31Map.idfc31_solicitudseguimientomap,
            fechapropuesta: rowspagina1[0].observaciones,
            tipoinstalacion: rowspagina1[1].observaciones,
            responsableinstalaciones: rowspagina1[2].observaciones,
            correoelectronico: rowspagina1[3].observaciones,
            telefono: rowspagina1[4].observaciones,
            domicilio: rowspagina1[5].observaciones,

            fechapropuestacheck: rowspagina1[0].incorrecto,
            tipoinstalacioncheck: rowspagina1[1].incorrecto,
            responsableinstalacionescheck: rowspagina1[2].incorrecto,
            correoelectronicocheck: rowspagina1[3].incorrecto,
            telefonocheck: rowspagina1[4].incorrecto,
            domiciliocheck: rowspagina1[5].incorrecto,
            idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
        })
        for (const i in rowspagina1) {
            if (rowspagina1?.[i].Campo === 'Muestreo') principalMap.push({ muestreo: rowspagina1[i].observaciones, muestreocheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Ingreso a maduración') principalMap.push({ ingresomaduracion: rowspagina1[i].observaciones, ingresomaduracioncheck: rowspagina1[i].incorrecto })
            if (rowspagina1?.[i].Campo === 'Liberación de maduración') principalMap.push({ liberacionmaduracion: rowspagina1[i].observaciones, liberacionmaduracioncheck: rowspagina1[i].incorrecto })
        }
        let obj_unidos = {}
        for (const i in principalMap) {
            obj_unidos = Object.assign(obj_unidos, principalMap[i])
        }

        let muestreoMap = []
        for (const producto of rowspagina2) {
            muestreoMap.push({
                muestreo: producto.observaciones, muestreocheck: producto.incorrecto,
                idfc31_anexomuestreo: producto.idfc31_anexomuestreo, idfc31_anexomuestreomap: producto.idfc31_anexomuestreomap
            })
        }
        let ingresoMap = []
        for (const producto of rowspagina3) {
            ingresoMap.push({
                ingreso: producto.observaciones, ingresocheck: producto.incorrecto,
                idfc31_anexoingresomaduracion: producto.idfc31_anexoingresomaduracion,
                idfc31_anexoingresomaduracionmap: producto.idfc31_anexoingresomaduracionmap
            })
        }
        let liberacionMap = []
        for (const producto of rowspagina4) {
            liberacionMap.push({
                liberacion: producto.observaciones, liberacioncheck: producto.incorrecto,
                idfc31_anexoliberacionmaduracion: producto.idfc31_anexoliberacionmaduracion,
                idfc31_anexoliberacionmaduracionmap: producto.idfc31_anexoliberacionmaduracionmap
            })
        }

        let archivosMuestreoMap = []
        for (const anexo in rowspagina5) {
            let nameid = rowspagina5[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DMAL") {
                archivosMuestreoMap.push({
                    estatuscheck: rowspagina5[anexo]?.incorrecto, observacion: rowspagina5[anexo]?.observaciones,
                    idfc_31archivomuestreo: rowspagina5[anexo]?.idfc_31archivomuestreo, idfc_31archivomuestreomap: rowspagina5[anexo]?.idMap
                })
            }
        }

        let archivosIngresoMap = []
        for (const anexo in rowspagina5) {
            let nameid = rowspagina5[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DIAL") {
                archivosIngresoMap.push({
                    estatuscheck: rowspagina5[anexo]?.incorrecto, observacion: rowspagina5[anexo]?.observaciones,
                    idfc_31archivoingreso: rowspagina5[anexo]?.idfc_31archivoingreso, idfc_31archivoingresomap: rowspagina5[anexo]?.idMap
                })
            }
        }

        let archivosMuestreo = []
        for (const anexo in rowspagina5) {
            let nameid = rowspagina5[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DMAL") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowspagina5[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina5[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowspagina5[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina5[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosMuestreo.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_31archivomuestreo: rowspagina5[anexo]?.idfc_31archivomuestreo
                })
            }
        }
        let archivosIngreso = []
        for (const anexo in rowspagina5) {
            let nameid = rowspagina5[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DIAL") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowspagina5[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina5[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowspagina5[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina5[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosIngreso.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_31archivoingreso: rowspagina5[anexo]?.idfc_31archivoingreso
                })
            }
        }
        let formato = { solicitud: principal[0], archivosMuestreo: archivosMuestreo, archivosIngreso: archivosIngreso }
        let formatoMap = {
            solicitud: obj_unidos, muestreoMap: muestreoMap, ingresoMap: ingresoMap, liberacionMap: liberacionMap,
            archivosMuestreoMap: archivosMuestreoMap, archivosIngresoMap: archivosIngresoMap
        }
        await dispatch(actualizarMapFC_31Accion(formatoMap))
        await dispatch(actualizarFC_31Solicitud(formato))
        return
    }
    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModalDeDocumentos}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            Para finalizar el trámite ingrese los siguientes datos
                        </Typography>
                        <FormularioDocumentacionFC_31
                            functionAcept={botonAceptarSolicitud}
                        ></FormularioDocumentacionFC_31>
                        <br />

                        <br />
                    </Box>
                </Modal>
            </div>

        )
    }
    const botonAceptarSolicitud = async (dataForm) => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_31Map) || JSON.stringify([]) === JSON.stringify(fc_31Map) || fc_31Map === null) {
            await agregarMapYActualizarFC_31()
        } else {
            await actualizarMapYActualizarFC_31()
        }
        const dataCliente = await dispatch(obtenerClienteByIdLogin(solicitud.idlogin))
        const detalle = await dispatch(obtenerSolicitudDetalleFC_31(solicitud.idfc31_solicitudseguimiento))
      
        let informacionmodalaceptada = {
            numerosolicitudservicios: dataForm?.numeroSolicitud,
            numcertificadonom: dataForm?.numCertificadoNOM,
            numplanevaluacion: dataForm?.numeroPlanEvaluacion,
            inspectorasignado: dataForm?.inspectorAsignado,
            credelcialinspector: dataForm?.credencialInspector,
            telefonoinspector: dataForm?.telefonoInspector
        }
        let actualizarinformacion = {
            idfc31_solicitudseguimiento: solicitud.idfc31_solicitudseguimiento,
            informacionmodalaceptada: informacionmodalaceptada
        }        
        await dispatch(actualizarFC_31SolicitudModal(actualizarinformacion))

        await generarOficios(detalle.payload, dataCliente.payload.cliente[0],dataForm)
        const idSolicitud = solicitud.idfc31_solicitudseguimiento
        const estatusNuevo = 4
        const idCliente = null
        const tablaFC_31 = 6
        const tabla = tablaFC_31
        await dispatch(actualizarFC_31Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
        ))
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')

    }
    const generarOficios = async (solicitudFC_31, dataCliente, dataForm) => {
        const data = {
            tipoSolicitud: 'FC_31',
            solicitudFC_31,
            dataCliente,
        }
        let servicio = ''
        if(solicitudFC_31.muestreo)servicio = 'MUESTREO'
        if(solicitudFC_31.ingresomaduracion)servicio = 'INGRESO A MADURACIÓN'
        if(solicitudFC_31.liberacionmaduracion)servicio = 'LIBERACIÓN DE MADURACIÓN'

        const dataSolicitudInspeccion = {   
            numeroSolicitud: dataForm.numeroSolicitud,
            numCertificadoNOM: dataForm.numCertificadoNOM,
            numeroTraslado: dataForm.numeroTraslado,
            otrosServicios: servicio,
            fechaInspeccion: solicitudFC_31.fechapropuesta.substring(0,10),
            numeroPlanEvaluacion: dataForm.numeroPlanEvaluacion,
            inspectorAsignado: dataForm.inspectorAsignado,
            credencialInspector: dataForm.credencialInspector,
            telefonoInspector: dataForm.telefonoInspector,
            checkFabrica: false,
            checkProductor: false,
            checkNacional: false,
            checkEnvasadora: false,
            checkEnvasador: false,
            checkExportacion: false,
            checkGranel: false,
            checkComercializador: false,
            checkPromocion: false,
            checkProductoTerminado: false,
            checkTraslado: false,
            checkMaduracion: false,
        }
        data.dataSolicitudInspeccion = dataSolicitudInspeccion
        await dispatch(generarDocumentosFC_31(data))
    }
    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = (params) => {
        setOpenModalDevolver(true)
    }
    const handleCloseModalDevolver = () => {
        setOpenModalDevolver(false)

    }
    const modalComponentDevolver = () => {
        return (
            <div>
                <Modal
                    open={openModalDevolver}
                    onClose={handleCloseModalDevolver}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleDevolver}>

                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>¡Advertencia!</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p>Está a punto de devolver esta solicitud.
                                Las observaciones serán enviadas al cliente para correcciones.</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />

                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonDevolverSolicitud() }}>CONTINUAR</button>
                            </div>
                            <div className={` col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDevolver() }}>CANCELAR</button>
                            </div>
                        </div>

                    </Box>
                </Modal>
            </div>
        )
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_31())
    }
    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {
                nombresParaPaginas[paginaActiva - 1] === 'Datos solicitante' ?
                    <div className='row justify-content-center'>
                        <div className='col-10'>
                            <TablaAtencionACliente rows={rowspagina1} api={{ handdleEditPrev }}></TablaAtencionACliente>
                        </div>
                    </div> : nombresParaPaginas[paginaActiva - 1] === 'Muestreo' ?
                        <div style={{ marginLeft: '5%' }}>
                            <TablaProductoMuestreo rows={rowspagina2} api={{ handdleEditPrev }} />
                        </div>

                        : nombresParaPaginas[paginaActiva - 1] === 'Ingreso a maduración' ?
                            <div style={{ marginLeft: '5%' }}>
                                <TablaProductoIngresoMaduracion rows={rowspagina3} api={{ handdleEditPrev }} />
                            </div>
                            : nombresParaPaginas[paginaActiva - 1] === 'Liberación de maduración' ?
                                <div style={{ marginLeft: '5%' }}>
                                    <TablaProductoLiberacionMaduracion rows={rowspagina4} api={{ handdleEditPrev }} />
                                </div>
                                : nombresParaPaginas[paginaActiva - 1] === 'Documentación' ?
                                    <Fragment>
                                        <div className='row justify-content-center'>
                                            <div className='col-12' style={{ marginLeft: '7%' }}>
                                                <TablaDocumentacion rows={rowspagina5} api={{ handdleEditPrev }}></TablaDocumentacion>
                                            </div>
                                        </div>
                                        {modoVerDetalle ?
                                            <div className="row text-center">
                                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                                </div>
                                            </div>
                                            :
                                            <div className="row text-center mt-4 mb-4">
                                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalAceptar} >Aceptar solicitud</button>
                                                </div>

                                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                                </div>
                                            </div>
                                        }
                                    </Fragment> : ''
            }
            {modalComponentDevolver()}
            {modalComponentAceptar()}
        </Fragment >
    )
}

export default withRouter(FC_31Component)
